(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vg-editorial-header"]) return;
  try {
    
if(!customElements.get('vg-navigation')){
 customElements.define('vg-navigation',class extends HTMLElement{
  connectedCallback(){
   if(this.controller)return;
   this.controller=new AbortController();const {signal}=this.controller;
   const bar=this.querySelector('.vg17-bar'),announcement=this.querySelector('.vg17-announcement');
   const syncHeader=()=>{this.frame=null;this.style.setProperty('--vg18-bar-height',bar.getBoundingClientRect().height+'px');this.classList.toggle('vg18-pinned',announcement.getBoundingClientRect().bottom<=0&&!this.inspectorActive);};
   const scheduleHeader=()=>{if(!this.frame)this.frame=requestAnimationFrame(syncHeader);};
   window.addEventListener('scroll',scheduleHeader,{passive:true,signal});
   window.addEventListener('resize',scheduleHeader,{passive:true,signal});
   window.addEventListener('pageshow',scheduleHeader,{signal});
   document.addEventListener('shopify:inspector:activate',()=>{this.inspectorActive=true;syncHeader();},{signal});
   document.addEventListener('shopify:inspector:deactivate',()=>{this.inspectorActive=false;syncHeader();},{signal});
   this.barObserver=new ResizeObserver(scheduleHeader);this.barObserver.observe(bar);syncHeader();
   const dialog=this.querySelector('dialog'),menu=this.querySelector('[data-menu-open]'),search=this.querySelector('[data-search-open]');
   const open=(trigger,focusSearch)=>{this.trigger=trigger;this.oldOverflow=document.documentElement.style.overflow;dialog.showModal();document.documentElement.style.overflow='hidden';menu.setAttribute('aria-expanded','true');if(focusSearch)dialog.querySelector('input[type=search]').focus();};
   menu.addEventListener('click',()=>open(menu,false),{signal});
   search.addEventListener('click',()=>open(search,true),{signal});
   this.querySelector('[data-menu-close]').addEventListener('click',()=>dialog.close(),{signal});
   dialog.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close();}},{signal});
   dialog.addEventListener('close',()=>{document.documentElement.style.overflow=this.oldOverflow||'';menu.setAttribute('aria-expanded','false');this.trigger?.focus();},{signal});
   dialog.querySelectorAll('a').forEach(a=>a.addEventListener('click',()=>dialog.close(),{signal}));
  }
  disconnectedCallback(){cancelAnimationFrame(this.frame);this.barObserver?.disconnect();if(this.querySelector('dialog')?.open)document.documentElement.style.overflow=this.oldOverflow||'';this.controller?.abort();this.controller=null;}
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vg-editorial-home"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('vg-runway')) {
  customElements.define('vg-runway', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready=true;
      this.abort=new AbortController();
      const signal=this.abort.signal;
      const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
      const videos=[...this.querySelectorAll('[data-vgr-film]')];
      const visible=new Set();
      const motions=[...this.querySelectorAll('[data-motion]')];
      let paused=reduced.matches;
      const sync=()=>{
        this.classList.toggle('is-paused',paused);
        motions.forEach(button=>{
          const label=paused?button.dataset.playLabel:button.dataset.pauseLabel;
          button.setAttribute('aria-pressed',String(paused));
          button.setAttribute('aria-label',label);
          button.querySelector('[data-motion-text]').textContent=label;
        });
        videos.forEach(video=>{
          video.muted=true;
          if (!paused && visible.has(video) && !document.hidden && video.getBoundingClientRect().width>0) {
            if (!video.getAttribute('src')) video.src=video.dataset.src;
            video.play().catch(()=>{});
          } else video.pause();
        });
      };
      motions.forEach(button=>{button.hidden=false;button.addEventListener('click',()=>{paused=!paused;sync();},{signal});});
      reduced.addEventListener('change',event=>{paused=event.matches;sync();},{signal});
      document.addEventListener('visibilitychange',sync,{signal});
      this.observer=new IntersectionObserver(entries=>{
        entries.forEach(entry=>{if(entry.isIntersecting)visible.add(entry.target);else visible.delete(entry.target);});
        sync();
      },{threshold:.05});
      videos.forEach(video=>{video.muted=true;this.observer.observe(video);});
      const rail=this.querySelector('.vg23-products');
      const previous=this.querySelector('[data-prev]');
      const next=this.querySelector('[data-next]');
      const progress=this.querySelector('[data-progress]');
      if (rail && previous && next) {
        previous.hidden=false;next.hidden=false;
        const refresh=()=>{
          const distance=Math.max(0,rail.scrollWidth-rail.clientWidth);
          const fraction=distance?Math.min(1,Math.max(0,rail.scrollLeft/distance)):0;
          previous.disabled=rail.scrollLeft<4;
          next.disabled=rail.scrollLeft+rail.clientWidth>=rail.scrollWidth-4;
          if(progress)progress.style.setProperty('--rail-position',`${fraction*100}%`);
        };
        const move=direction=>rail.scrollBy({left:direction*(rail.clientWidth+parseFloat(getComputedStyle(rail).columnGap)),behavior:reduced.matches?'instant':'smooth'});
        previous.addEventListener('click',()=>move(-1),{signal});
        next.addEventListener('click',()=>move(1),{signal});
        rail.addEventListener('scroll',refresh,{passive:true,signal});
        this.resize=new ResizeObserver(()=>{refresh();sync();});
        this.resize.observe(rail);
        refresh();
      }
      sync();
    }
    disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();this.resize?.disconnect();this.querySelectorAll('video').forEach(video=>video.pause());this.ready=false;}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vg-editorial-product"]) return;
  try {
    
if (!customElements.get('vg-editorial-product')) {
  customElements.define('vg-editorial-product', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.data = JSON.parse(this.querySelector('[data-vge-data]').textContent);
      this.selects = [...this.querySelectorAll('[data-option-index]')];
      this.quantity = this.querySelector('[data-vge-quantity]');
      this.image = this.querySelector('.vge-pdp-main-image');
      this.link = this.querySelector('[data-vge-order]');
      this.dialog = this.querySelector('[data-vge-size-dialog]');
      this.photoDialog = this.querySelector('[data-photo-dialog]');
      this.photos = [...this.querySelectorAll('[data-photo]')];
      this.addEventListener('change', e => {
        if (e.target.matches('[data-size-index], [data-color-index]')) {
          this.selects[Number(e.target.dataset.sizeIndex ?? e.target.dataset.colorIndex)].value = e.target.value;
          this.update(true);
        } else if (e.target.matches('[data-option-index], [data-vge-quantity]')) this.update(e.target.matches('[data-option-index]'));
      });
      this.quantity.addEventListener('input', () => this.update(false));
      this.quantity.addEventListener('blur', () => { const count = this.clampQuantity(); if (this.quantity.value !== String(count)) this.quantity.value = count; });
      this.addEventListener('click', e => {
        const thumb = e.target.closest('[data-photo]');
        if (thumb) this.showPhoto(thumb.dataset.photo, thumb.dataset.photoAlt, thumb.dataset.photoId);
        if (e.target.closest('[data-photo-open]') && !this.image.hidden && Date.now() > (this.swipedUntil || 0)) { this.syncPhotoDialog(); this.photoDialog.showModal(); }
        if (e.target.closest('[data-photo-close]')) this.photoDialog.close();
        if (e.target.closest('[data-photo-prev]')) this.stepPhoto(-1);
        if (e.target.closest('[data-photo-next]')) this.stepPhoto(1);
        if (e.target.closest('[data-vge-size-open]')) this.dialog.showModal();
        if (e.target.closest('[data-vge-size-close]')) this.dialog.close();
        if (e.target.closest('[data-vge-order][aria-disabled="true"], [data-vge-wholesale][aria-disabled="true"]')) e.preventDefault();
      });
      this.dialog.addEventListener('click', e => { if (e.target === this.dialog) this.dialog.close(); });
      this.photoDialog.addEventListener('click', e => { if (e.target === this.photoDialog) this.photoDialog.close(); });
      this.photoDialog.addEventListener('keydown', e => { if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') { e.preventDefault(); this.stepPhoto(e.key === 'ArrowLeft' ? -1 : 1); } });
      const gallery = this.querySelector('.vge-pdp-main');
      gallery.addEventListener('touchstart', e => { this.touchStart = [e.changedTouches[0].clientX, e.changedTouches[0].clientY]; }, {passive:true});
      gallery.addEventListener('touchend', e => {
        if (!this.touchStart || this.image.hidden) return;
        const dx = e.changedTouches[0].clientX - this.touchStart[0];
        const dy = e.changedTouches[0].clientY - this.touchStart[1];
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) { this.swipedUntil = Date.now() + 400; this.stepPhoto(dx < 0 ? 1 : -1); }
        this.touchStart = null;
      }, {passive:true});
      this.sampleSwatches();
      this.update(true);
    }
    sampleSwatches() {
      this.querySelectorAll('.vge-color-dot-photo').forEach(dot => {
        const radio = dot.parentElement.querySelector('[data-color-photo]');
        if (!radio) return;
        const source = new URL(radio.dataset.colorPhoto, location.href);
        source.searchParams.set('width', '180');
        const sample = new Image();
        sample.crossOrigin = 'anonymous';
        sample.onload = () => {
          try {
            const canvas = document.createElement('canvas');
            canvas.width = sample.naturalWidth;
            canvas.height = sample.naturalHeight;
            const context = canvas.getContext('2d', {willReadFrequently: true});
            context.drawImage(sample, 0, 0);
            const region = context.getImageData(Math.floor(canvas.width * .45), Math.floor(canvas.height * .35), Math.max(1, Math.floor(canvas.width * .1)), Math.max(1, Math.floor(canvas.height * .2))).data;
            const bins = new Map();
            for (let i = 0; i < region.length; i += 4) {
              if (region[i + 3] < 200) continue;
              const key = [region[i], region[i + 1], region[i + 2]].map(v => Math.floor(v / 24)).join(',');
              const bin = bins.get(key) || [0, 0, 0, 0];
              bin[0]++; bin[1] += region[i]; bin[2] += region[i + 1]; bin[3] += region[i + 2];
              bins.set(key, bin);
            }
            const best = [...bins.values()].sort((a, b) => b[0] - a[0])[0];
            if (best) {
              dot.style.backgroundColor = `rgb(${best.slice(1).map(v => Math.round(v / best[0])).join(',')})`;
              dot.style.backgroundImage = 'none';
            }
          } catch (_) {}
        };
        sample.src = source.href;
      });
    }
    syncPhotoDialog() {
      const image = this.querySelector('.vge-photo-expanded');
      image.src = this.image.src;
      image.removeAttribute('srcset');
      image.alt = this.image.alt;
      const index = this.photos.findIndex(t => t.getAttribute('aria-pressed') === 'true');
      this.querySelector('[data-photo-counter]').textContent = `${Math.max(0, index) + 1} / ${this.photos.length}`;
    }
    stepPhoto(direction) {
      if (!this.photos.length) return;
      const index = this.photos.findIndex(t => t.getAttribute('aria-pressed') === 'true');
      const thumb = this.photos[(Math.max(0, index) + direction + this.photos.length) % this.photos.length];
      this.showPhoto(thumb.dataset.photo, thumb.dataset.photoAlt, thumb.dataset.photoId);
      this.syncPhotoDialog();
    }
    showPhoto(src, alt, id) {
      this.image.hidden = false;
      this.querySelector('[data-photo-missing]').hidden = true;
      this.querySelector('[data-photo-open]').disabled = false;
      this.querySelector('.vge-photo-hint').hidden = false;
      this.image.src = src;
      this.image.removeAttribute('srcset');
      this.image.alt = alt || this.dataset.productTitle;
      this.querySelectorAll('[data-photo]').forEach(t => t.setAttribute('aria-pressed', String(id ? t.dataset.photoId === String(id) : t.dataset.photo === src)));
      const index = this.photos.findIndex(t => t.getAttribute('aria-pressed') === 'true');
      this.querySelector('[data-gallery-counter]').textContent = `${Math.max(0,index) + 1} / ${this.photos.length}`;
    }
    clampQuantity() {
      return Math.min(99, Math.max(1, Math.trunc(Number(this.quantity.value) || 1)));
    }
    update(changeImage) {
      const options = this.selects.map(s => s.value);
      const variant = this.data.variants.find(v => v.options.every((o, i) => o === options[i]));
      const colorChoice = this.querySelector('[data-color-index]:checked');
      if (colorChoice) {
        this.querySelector('[data-color-name]').textContent = colorChoice.value;
        if (changeImage) {
          if (colorChoice.dataset.colorPhoto) {
            this.showPhoto(colorChoice.dataset.colorPhoto, this.dataset.productTitle + ' · ' + colorChoice.value, colorChoice.dataset.colorImageId);
          } else {
            this.image.hidden = true;
            this.querySelector('[data-photo-missing]').hidden = false;
            this.querySelector('[data-photo-open]').disabled = true;
            this.querySelector('.vge-photo-hint').hidden = true;
            this.photos.forEach(t => t.setAttribute('aria-pressed', 'false'));
          }
        }
      }
      const count = this.clampQuantity();
      this.querySelector('[data-selection]').textContent = options.join(' / ') + ' · ' + this.data.quantityLabel + ': ' + count;
      const status = this.querySelector('[data-status]');
      const fullUrl = new URL(this.dataset.productUrl);
      const wholesale = this.querySelector('[data-vge-wholesale]');
      const sizeContact = this.querySelector('[data-vge-size-contact]');
      if (variant) fullUrl.searchParams.set('variant', variant.id);
      sizeContact.href = 'https://wa.me/51944580534?text=' + encodeURIComponent([this.data.sizeMessage, this.dataset.productTitle, ...this.data.options.map((n,i) => `${n}: ${options[i]}`), fullUrl.href].join('\n'));
      if (!variant) {
        status.textContent = this.data.noVariant;
        this.link.setAttribute('aria-disabled', 'true');
        this.link.removeAttribute('href');
        wholesale.setAttribute('aria-disabled', 'true');
        wholesale.removeAttribute('href');
        return;
      }
      this.link.removeAttribute('aria-disabled');
      wholesale.removeAttribute('aria-disabled');
      fullUrl.searchParams.set('variant', variant.id);
      const lines = [this.data.message, this.dataset.productTitle, ...this.data.options.map((n, i) => `${n}: ${options[i]}`), `${this.data.quantityLabel}: ${count}`, fullUrl.href];
      this.link.href = 'https://wa.me/51944580534?text=' + encodeURIComponent(lines.join('\n'));
      wholesale.href = 'https://wa.me/51944580534?text=' + encodeURIComponent([this.data.wholesaleMessage, ...lines.slice(1)].join('\n'));
      status.textContent = variant.available ? this.data.confirmStock : this.data.unavailable;
      const format = cents => new Intl.NumberFormat('es-PE', {style:'currency',currency:this.dataset.currency || 'PEN'}).format(cents / 100);
      this.querySelector('[data-price]').textContent = format(variant.price);
      const compare = this.querySelector('[data-compare]');
      compare.hidden = !(variant.compare_at_price > variant.price);
      compare.textContent = compare.hidden ? '' : format(variant.compare_at_price);
      if (changeImage && !colorChoice && variant.featured_image) {
        const thumb = this.querySelector('[data-photo-id="' + variant.featured_image.id + '"]');
        if (thumb) {
          this.showPhoto(thumb.dataset.photo, thumb.dataset.photoAlt, thumb.dataset.photoId);
        } else {
          const src = variant.featured_image.src;
          this.showPhoto(src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=1500', variant.featured_image.alt);
        }
      }
      const currentUrl = new URL(location.href);
      currentUrl.searchParams.set('variant', variant.id);
      history.replaceState(null, '', currentUrl.href);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vg-footer"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('vg-footer-navigation')){
  customElements.define('vg-footer-navigation',class extends HTMLElement{
    connectedCallback(){
      if(this.controller)return;
      this.controller=new AbortController();
      const {signal}=this.controller;
      const desktop=window.matchMedia('(min-width:750px)');
      const groups=[...this.querySelectorAll('.vgft25-group')];
      const sync=()=>groups.forEach(group=>{
        group.open=desktop.matches;
        group.querySelector('summary').tabIndex=desktop.matches?-1:0;
      });
      groups.forEach(group=>group.querySelector('summary').addEventListener('click',event=>{
        if(desktop.matches)event.preventDefault();
      },{signal}));
      desktop.addEventListener('change',sync,{signal});
      sync();
    }
    disconnectedCallback(){this.controller?.abort();this.controller=null;}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vg-stores"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('vg-stores-directory')) {
  customElements.define('vg-stores-directory', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.abort = new AbortController();
      const signal = this.abort.signal;
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      const records = [...this.querySelectorAll('[data-vgst24-film]')].map(frame => ({
        video: frame.querySelector('[data-vgst24-video]'),
        button: frame.querySelector('[data-vgst24-toggle]'),
        visible: false,
        paused: reduced.matches
      })).filter(record => record.video && record.button);
      this.records = records;
      const sync = record => {
        const label = record.paused ? record.button.dataset.play : record.button.dataset.pause;
        record.button.setAttribute('aria-label', label);
        record.button.setAttribute('aria-pressed', String(record.paused));
        record.button.querySelector('[data-vgst24-text]').textContent = label;
        record.button.querySelector('[data-vgst24-icon]').textContent = record.paused ? '▷' : 'Ⅱ';
        record.video.muted = true;
        if (record.visible && !record.paused && !document.hidden) {
          if (!record.video.getAttribute('src')) record.video.src = record.video.dataset.src;
          record.video.play().catch(() => {});
        } else {
          record.video.pause();
        }
      };
      const byVideo = new Map(records.map(record => [record.video, record]));
      this.observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          const record = byVideo.get(entry.target);
          if (!record) return;
          record.visible = entry.isIntersecting && entry.intersectionRatio >= 0.05;
          sync(record);
        });
      }, {threshold: [0, 0.05]});
      records.forEach(record => {
        record.button.hidden = false;
        record.button.addEventListener('click', () => {record.paused = !record.paused; sync(record);}, {signal});
        this.observer.observe(record.video);
        sync(record);
      });
      document.addEventListener('visibilitychange', () => records.forEach(sync), {signal});
      reduced.addEventListener('change', event => records.forEach(record => {record.paused = event.matches; sync(record);}), {signal});
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      this.records?.forEach(record => record.video.pause());
      this.ready = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
